/* global global */

// Third-party imports
import axios from 'axios';

// Local imports
// polyfills must be applied before everything else
import '../../polyfill/index.js';

import * as datalayer from '../../datalayer/data/sponsorship.js';
import * as feature_slider from './feature_slider.js';
import * as tealium from '../../datalayer/tealium.js';
import * as global_mod from '../../global/index.js';
import * as tocart from '../../sponsorship/tocart.js';
import { PAGE_VARS, PageKind } from '../vars.js';
import { getDataInputs } from '../../sponsorship/tocart.js';
import { init_index } from '../../sponsorship/init.js';
import { push_data_object } from '../../datalayer/gtm/gtm_push.js';

import * as shopify_data from './shopify_data.js';

// --------------------------------------------------------------------------
// Module vars
// --------------------------------------------------------------------------
// Module name
export const MODULE_NAME = 'spshhome';

export let global_vars = {};

export const MIDPAGE_CTA_DATALAYER_SUFFIX = ' With CTA';

// --------------------------------------------------------------------------
// Functions
// --------------------------------------------------------------------------

class ShopifyData {
    constructor(data_element) {
        this.data_element = data_element;
    }

    run() {
        let data = this.data_element.dataset;
        if (data.clear_localstorage === 'true') {
            shopify_data.clear_local_storage();
        }
    }
}

function init_pagevars() {
    PAGE_VARS.kind = PageKind.Sponsorship;
}

// global is the window object when run in browser context
function clear_local_storage(global) {
    const SHOPIFY_DATA = shopify_data.SHOPIFY_DATA;

    if (SHOPIFY_DATA.clear_local_storage) {
        let storage = global.localStorage;
        let key = 'SIEFLAG';
        if (storage.getItem(key) !== null) {
            storage.removeItem(key);
        }
    }
}

function build_tocart_callbacks(global) {
    let tocart_event = tocart.create_tocart_event();
    let ret = {
        build_data_input: () => {
            return getDataInputs(global);
        },
        tocart_event: tocart_event,
        form_onsubmit: after_func => {
            let tocart_form = global.document.querySelector('#sponsorbtn-form');
            tocart_form.addEventListener('submit', event => {
                global.document.dispatchEvent(tocart_event);

                after_func(event);
            });
        },
    };
    return ret;
}

async function get_filterdata(global) {
    let url = global.document.body.dataset.filterJs;
    let response = await axios.get(url);

    // The needed data in the returned json object is contained in the 'data'
    // key
    return response.data.data;
}

function build_custom_data(global) {
    let data = {
        collection: 'sponsorships',
        tocart_callbacks: build_tocart_callbacks(global),
        page: {
            midpage_cta_datalayer_suffix: MIDPAGE_CTA_DATALAYER_SUFFIX,
        },
        filterdata_callback: get_filterdata,
        update_filters: filters => {
            return filters;
        },
    };

    return data;
}

function initLongestWaitingListener(global) {
    //== gtm-push: Longest Waiting Checkbox Clicked ==//
    let longestWaitingCheckbox = global.document.getElementById(
        'longestWaitingCheck'
    );
    longestWaitingCheckbox.addEventListener('change', () => {
        const action = longestWaitingCheckbox.checked
            ? 'Check on'
            : 'Check off';
        let data_object = {
            event: 'checkBox',
            event_category: 'Ecommerce',
            event_action: action,
            event_label: 'Longest Wait Time',
            event_value: 'undefined',
        };
        push_data_object(data_object);
    });
}

function initialize(global) {
    let data_element = global.document.getElementById('spshhome-data');
    let shpdata = new ShopifyData(data_element);
    shpdata.run();

    clear_local_storage(global);

    let custom_data = build_custom_data(global);

    if (PAGE_VARS.kind === PageKind.EventsApp) {
        // Setup datalayer for capturing spsh data when sending spsh to cart
        datalayer.onclick_spsh_button(
            global,
            global.utag_data,
            custom_data.tocart_callbacks.tocart_event
        );
    }

    init_index(global, custom_data);
    initLongestWaitingListener(global);
}

export function main() {
    // Initialize all page vars
    init_pagevars();

    // Create object to pass to global initialization
    let all_modules = [feature_slider];
    all_modules.push.apply(all_modules, global_mod.__all__);

    let spshhome_mod = {
        MODULE_NAME,
        global_vars,
        initialize,
    };

    all_modules.push(spshhome_mod);

    // Insert datalayer setup module and tealium module at the beginning and end
    // of the modules array respectively
    all_modules = tealium.wrap_module_array(all_modules);

    // Initialize globals
    // The ``global`` global variable will be ``window`` when run in a browser
    // context.
    global_mod.initialize(global, all_modules);
}
